__turbopack_context__.v({
  "brandRow": "Hero-module__9tGfhG__brandRow",
  "content": "Hero-module__9tGfhG__content",
  "ctaRow": "Hero-module__9tGfhG__ctaRow",
  "divider": "Hero-module__9tGfhG__divider",
  "heroBuyNowButton": "Hero-module__9tGfhG__heroBuyNowButton",
  "heroSection": "Hero-module__9tGfhG__heroSection",
  "leftContent": "Hero-module__9tGfhG__leftContent",
  "title": "Hero-module__9tGfhG__title",
  "titleLine": "Hero-module__9tGfhG__titleLine",
  "uhLogoType": "Hero-module__9tGfhG__uhLogoType",
});
